import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}timesheets/`;
const API_ROOT = process.env.VUE_APP_API_URL;

export default {
  getAll(params = {}) {
    return axios.get(API_URL, { params, headers: buildHeaders() });
  },
   getMine(params = {}) { 
    return axios.get(`${API_ROOT}my/timesheets`, { params, headers: buildHeaders() });
  },
  get(id) {
    return axios.get(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  create(data) {
    return axios.post(API_URL, data, { headers: buildHeaders() });
  },
  update(id, data) {
    return axios.put(`${API_URL}${id}`, data, { headers: buildHeaders() });
  },
  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },
  bulkDelete(ids) {
    return axios.post(`${API_URL}bulk-delete`, { ids }, { headers: buildHeaders() });
  },
  approve(id, payload) {
    return axios.post(`${API_URL}${id}/approve`, payload, { headers: buildHeaders() });
  },

  bulkApprove(ids, status, notes = "") { 
    return axios.post(`${API_URL}bulk-approve`, { ids, status, notes }, { headers: buildHeaders() });
  },
  exportCsv(params = {}) { 
    return axios.get(`${API_URL}export/csv`, { params, headers: buildHeaders(), responseType: 'blob' });
  },
  exportPdf(params = {}) { 
    return axios.get(`${API_URL}export/pdf`, { params, headers: buildHeaders(), responseType: 'blob' });
  },
};
